import { useMemo } from "react";
import { IStyleFunctionOrObject } from "@fluentui/merge-styles/lib/IStyleFunction";
import { IDetailsColumnStyleProps, IDetailsColumnStyles } from "@fluentui/react/lib/DetailsList";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { textOverflow } from "Utils/Styles";

const classNames = {
  host: `CheckboxRendererHost`,
  root: `CheckboxRenderer`,
  tooltip: `CheckboxRendererTooltip`
};

export function useCheckboxRendererStyles(
  styles?: IStyleFunctionOrObject<IDetailsColumnStyleProps, IDetailsColumnStyles>
) {
  return useMemo(
    () => mergeStyleSets(
      {
        host: [classNames.host, {}],
        root: [
          classNames.root,
          {
            width: `100%`,
            ...textOverflow
          }
        ],
        tooltip: [
          classNames.tooltip,
          {
            padding: 0
          }
        ]
      },
      { host: styles }
    ),
    [styles]
  );
}
